import React, { Component } from 'react';
import { connect } from 'react-redux';
import './prBidRequest.scss';
import { Modal, Button } from 'antd';
import { fromValidate, history } from '../../../helpers'
import Header from "../../../layout/DefaultLayout/Header";
import Avatar from "../../../images/img_avatar.png";
const { confirm } = Modal;

class PrBidRequest extends Component {

   constructor(props) {
      super(props);
      this.state = {
         formError: {},
         formSubmit: false,
         user: {},
         userNumber: '****7890',
         isSuccess: true,
      }
   }

   showConfirm = () => {
    confirm({
        title: 'You will be charged 50 credit points!',
        content: '45 Credits will be refunded, if bidding is not approved by the customer. Do you want to continue?',
        okText: 'YES',
        cancelText: 'NO',
    });
  }

//    showModalBid = () => {
//     this.setState({
//         visibleBid: true,
//     });
//     };

//     handleOkBid = e => {
//         console.log(e);
//         this.setState({
//             visibleBid: false,
//         });
//     };

//     handleCancelBid = e => {
//         console.log(e);
//         this.setState({
//             visibleBid: false,
//         });
//     };


   render() {
      const { user, formError, formSubmit, userNumber, isSuccess } = this.state;
      return (
         <div>
            <Header></Header>
            <div className='pr-container'>
               <div className="main-heading-txt">Bid Requests</div>
             

               <div className="request-box">
                 <div className="row">
                     <div className="col-1">
                     <img src={Avatar} className="avatar-image" alt="" />
                     </div>
                     <div className="col-4">
                         <div className='card-heading-text'>What is Lorem Ipsum?</div>
                         <div className='card-heading-sub-text'>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</div>
                     </div>
                     <div className="col-2">
                         <div className='card-date-text'>22/08/2020</div>
                     </div>
                    
                     <div className="col-2">
                         <div className='card-price-text'>&#8377;200</div>
                     </div>
                     <div className="col-2">
                         <div className='card-status-text'>Panding</div>
                     </div>
                     <div className="col-1">
                         <div className='card-bid-now-btn' onClick={() => this.showConfirm()}>Bid Now</div>
                     </div>
                 </div>
               </div>

               <div className="request-box">
                 <div className="row">
                     <div className="col-1">
                     <img src={Avatar} className="avatar-image" alt="" />
                     </div>
                     <div className="col-4">
                         <div className='card-heading-text'>What is Lorem Ipsum?</div>
                         <div className='card-heading-sub-text'>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</div>
                     </div>
                     <div className="col-2">
                         <div className='card-date-text'>22/08/2020</div>
                     </div>
                    
                     <div className="col-2">
                         <div className='card-price-text'>&#8377;200</div>
                     </div>
                     <div className="col-2">
                         <div className='card-status-text progress-txt'>In-Progress</div>
                     </div>
                     <div className="col-1">
                         <div className='card-bid-now-btn' onClick={() => this.showConfirm()}>Bid Now</div>
                     </div>
                 </div>
               </div>

               <div className="request-box">
                 <div className="row">
                     <div className="col-1">
                     <img src={Avatar} className="avatar-image" alt="" />
                     </div>
                     <div className="col-4">
                         <div className='card-heading-text'>What is Lorem Ipsum?</div>
                         <div className='card-heading-sub-text'>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</div>
                     </div>
                     <div className="col-2">
                         <div className='card-date-text'>22/08/2020</div>
                     </div>
                    
                     <div className="col-2">
                         <div className='card-price-text'>&#8377;200</div>
                     </div>
                     <div className="col-2">
                         <div className='card-status-text complated-txt'>Complated</div>
                     </div>
                     <div className="col-1">
                         <div className='card-bid-now-btn' onClick={() => this.showConfirm()} >Bid Now</div>
                         {/* <Modal
                            title={<div className="prbid-now-btn">Bid Now</div>}
                            visible={this.state.visibleBid}
                            onOk={this.handleOkBid}
                            onCancel={this.handleCancelBid}
                            >
                                <div>hfvhghghgghghggh</div>
                            
                        </Modal> */}
                        
                     </div>
                 </div>
               </div>

               

            </div>
         </div>
      )
   }
}

function mapStateToProps(state) {
   const { user } = state.authentication;
   return {
      user,
   }
}
export default connect(mapStateToProps)(PrBidRequest);